import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _OutLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", d: "M20 3v-.5h.5V3zm-9.646 10.354a.5.5 0 0 1-.708-.708zM19.5 11V3h1v8zm.5-7.5h-8v-1h8zm.354-.146-10 10-.708-.708 10-10z" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M19 15c0 1.87 0 2.804-.402 3.5a3 3 0 0 1-1.098 1.098C16.804 20 15.87 20 14 20H9c-2.828 0-4.243 0-5.121-.879C3 18.243 3 16.828 3 14V9c0-1.87 0-2.804.402-3.5A3 3 0 0 1 4.5 4.402C5.196 4 6.13 4 8 4" })] }) });
}
const OutLight = forwardRef(_OutLight);
export { OutLight };
